'use client'

import { useGetAllProductsMutation } from '@/shared/api-rtk'
import { useRouter } from 'next/navigation'
import PaginationBtns from '@/shared/components/Pagination'

export const Pagination = ({
    setConfigRequest,
    currentConfig,
    products,
    setProducts,
    pageQuantity,
    scrollToRef,
    loadMoreCounter,
    changeLoadMoreCounter,
}) => {
    if (pageQuantity < 2) {
        return null
    }

    const [getALl] = useGetAllProductsMutation()
    const router = useRouter()

    const navigate = (path) => router.push(path)

    const hanleLoadMore = async () => {
        try {
            const response = await getALl({
                ...currentConfig,
                current_page: loadMoreCounter + 1,
            }).unwrap()

            if (response.result === 'success') {
                setProducts([...products, ...Object.values(response.data)])
                changeLoadMoreCounter(loadMoreCounter + 1)
            } else {
                throw new Error('Load more products error')
            }
        } catch (error) {
            navigate('/error')
        }
    }

    const handlePaginationButton = async (pageNumber) => {
        try {
            const response = await getALl({
                ...currentConfig,
                current_page: pageNumber,
            }).unwrap()

            if (response.result === 'success') {
                setProducts(Object.values(response.data))
                setConfigRequest({
                    ...currentConfig,
                    current_page: pageNumber,
                })
                changeLoadMoreCounter(pageNumber)

                scrollToRef()
            } else {
                throw new Error('Load more products error')
            }
        } catch (error) {
            navigate('/error')
        }
    }

    const offset = 2
    const limitReviews = pageQuantity > loadMoreCounter

    return (
        <PaginationBtns
            pageQuantity={pageQuantity}
            currentPage={currentConfig.current_page}
            offset={offset}
            handlePaginationButton={handlePaginationButton}
            limitReviews={limitReviews}
            handleShowMore={hanleLoadMore}
        />
    )
}
